// import appInfor from "@src/config/appInfor"
import registerInfo from "@src/global/registerInfo"
import configBaseUrl from "@/config/baseUrl"

export default class RouterService {
  constructor() {
    const env = registerInfo.env
    const appName = registerInfo.appName
    this.appName = appName
    this.env = env
    this.firstFalg = true
  }
  /**
   * @description 路由守卫
   * @author liupl
   * @date 2021-10-21
   * @memberof RouterService
   */
  beforeEach({ to, Vue }) {
    if (this.firstFalg) {
      this._ininLanguage(to, Vue)
      this.firstFalg = false
    }
  }

  _ininLanguage(to, Vue) {
    const loginUrl = configBaseUrl[registerInfo.env].VUE_APP_APICASBASEURL
    const reg = new RegExp(loginUrl)
    const res = new RegExp("/en-US/")
    if (reg.test(document.referrer) && performance.navigation.type !== 1) {
      const path = location.pathname
      if (res.test(path)) {
        localStorage.setItem("VOC-LANGUAGE", "en")
        Vue.config.lang = "en"
      }
    }
  }
}
